export const MANAGE_CARDS_LOADING_STATES = {
    SAVED_CARDS_LOADING: "SAVED_CARDS_LOADING",
    SAVED_CARDS_READY: "SAVED_CARDS_READY",
    ADD_CARD_LOADING: "ADD_CARD_LOADING",
    ADD_CARD_READY: "ADD_CARD_READY",
}

export const MANAGE_CARDS_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_CARDS_LOADING_STATES.SAVED_CARDS_LOADING]: "",
    [MANAGE_CARDS_LOADING_STATES.ADD_CARD_LOADING]: "",
}